import React from 'react';
import './IphoneAppDevelopment.css'; // Import CSS file
import { Link } from 'react-router-dom';

const IphoneAppDevelopment = () => {
  return (
    <div className="iphone-app-development-container">
      {/* Hero Section */}
      <section className="hero-section-ipad">
        <div className="hero-content-ipad">
          <h1 className="hero-heading-ipad">Build Your Vision with Expert iOS App Development</h1>
          <p className="hero-text-ipad"  style={{color:'white'}}>
            Our team of expert developers crafts innovative, scalable, and secure iOS applications tailored to your business needs.
          </p>
        </div>
        <div className="hero-video-ipad">
          <video
            src="videos/23.mp4"
            alt="iPhone App Video"
            className="iphone-video-ipad"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us-ipad">
        <h2 className="section-heading-ipad">Why Choose Us?</h2>
        <div className="features-container-ipad">
          <div className="feature-item-ipad">
            <h3 className="feature-title-ipad">Expert Team</h3>
            <p>Our developers have years of experience building high-performance apps.</p>
          </div>
          <div className="feature-item-ipad">
            <h3 className="feature-title-ipad">Scalable Solutions</h3>
            <p>We create apps that grow with your business, ensuring long-term success.</p>
          </div>
          <div className="feature-item-ipad">
            <h3 className="feature-title-ipad">Custom Designs</h3>
            <p>We offer tailored designs to meet your brand's unique needs and user expectations.</p>
          </div>
        </div>
      </section>
{/* 
      <section className="statistics-section-ipad">
        <h2 className="section-heading-ipad">Our Achievements</h2>
        <div className="stats-grid-ipad">
          <div className="stat-item-ipad">
            <h3>17+</h3>
            <p>Years of Experience</p>
          </div>
          <div className="stat-item-ipad">
            <h3>1,450+</h3>
            <p>Projects Delivered</p>
          </div>
          <div className="stat-item-ipad">
            <h3>670+</h3>
            <p>Happy Clients</p>
          </div>
          <div className="stat-item-ipad">
            <h3>60+</h3>
            <p>Apps Developed</p>
          </div>
        </div>
      </section> */}

      {/* Our Process Section */}
      <section className="process-section-ipad">
        <h2 className="section-heading-ipad">Our iOS App Development Process</h2>
        <div className="process-steps-ipad">
          <div className="process-step-ipad">
            <img
              src="images/apple/idoa.webp"
              alt="Ideation"
              className="process-icon-ipad"
            />
            <h3>1. Ideation</h3>
            <p>We collaborate with you to refine your ideas into a workable plan.</p>
          </div>
          <div className="process-step-ipad">
            <img
              src="images/apple/development.jpg"
              alt="Design & Development"
              className="process-icon-ipad"
            />
            <h3>2. Design & Development</h3>
            <p>We create intuitive UI/UX and code the app using the latest technologies.</p>
          </div>
          <div className="process-step-ipad">
            <img
              src="images/apple/test.jpg"
              alt="Testing"
              className="process-icon-ipad"
            />
            <h3>3. Testing</h3>
            <p>Our quality assurance team ensures the app is bug-free and smooth across devices.</p>
          </div>
          <div className="process-step-ipad">
            <img
              src="images/apple/lunch.jpg"
              alt="Launch & Support"
              className="process-icon-ipad"
            />
            <h3>4. Launch & Support</h3>
            <p>We help you launch your app and provide ongoing updates and support.</p>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="services-section-ipad">
        <h2 className="section-heading-ipad">Our Services</h2>
        <div className="services-list-ipad">
          <div className="service-item-ipad">
            <h3>iPhone App Development</h3>
            <p>Innovative iPhone applications with rich functionality and design.</p>
          </div>
          <div className="service-item-ipad">
            <h3>iPad App Development</h3>
            <p>Responsive and optimized apps for iPad’s large screen.</p>
          </div>
          <div className="service-item-ipad">
            <h3>Apple Watch App Development</h3>
            <p>Smartwatch apps designed for seamless integration with iOS.</p>
          </div>
          <div className="service-item-ipad">
            <h3>App Store Optimization (ASO)</h3>
            <p>Increase visibility and engagement with effective ASO strategies.</p>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta-ipad">
        <h2 className="cta-heading-ipad">Ready to Develop Your iOS App?</h2>
        <p className="cta-text-ipad"  style={{color:'wheat'}}>
          Let’s talk about your project. Our team is ready to bring your ideas to life.
        </p>
        <Link to="/ContactPage">
  <button className="cta-button-ipad">Contact Us</button>
</Link>

      </section>
    </div>
  );
};

export default IphoneAppDevelopment;
